import useActivityAcknowledgementContext from '/druid/private/useContext';

export default function useGetHasAcknoweledgedByActivityKey(): (activityKey: string) => boolean | undefined {
  return useActivityAcknowledgementContext().getHasAcknowledgedByActivityKey;
}
